import { segment } from '../SegmentAnalyticsUtils';

//FIXME:Give type to userProfileData
export const sendSegmentIdentifyAnalytics = (
  userProfileData,
  requestObject: any = {}
) => {
  let gender = userProfileData.gender || requestObject.gender;
  gender = gender ? gender.toLowerCase() : '';
  segment.identify(userProfileData.userId, {
    firstName:
      requestObject.name ||
      requestObject.fullName ||
      userProfileData.name ||
      '',
    lastName: userProfileData.lastName || requestObject.last_name || '',
    gender: gender,
    avatar:
      userProfileData.profilePicUrl || requestObject.profile_pic_url || '',
    phone: `${userProfileData.phoneNumber}`,
    email: userProfileData.email || requestObject.email || '',
    we_whatsapp_opt_in:
      requestObject.whatsappInfoStatus !== undefined
        ? requestObject.whatsappInfoStatus
        : undefined
  });
};

export const sendSegmentIdentifyAnalyticsWithCountryCode = (
  userProfileData,
  requestObject: any = {},
  identify
) => {
  let gender = userProfileData.gender || requestObject.gender;
  gender = gender ? gender.toLowerCase() : '';
  identify(userProfileData.userId, {
    firstName: userProfileData.name || requestObject.name || '',
    lastName: userProfileData.lastName || requestObject.last_name || '',
    gender: gender,
    avatar:
      userProfileData.profilePicUrl || requestObject.profile_pic_url || '',
    phone: `${userProfileData.phoneNumber}`,
    email: userProfileData.email || requestObject.email || '',
    countryCode: userProfileData.countryCode || requestObject.countryCode || '',
    we_whatsapp_opt_in:
      requestObject.whatsappInfoStatus !== undefined
        ? requestObject.whatsappInfoStatus
        : undefined
  });
};

export const sendSegmentIdentifyEventWithBackendResponse = (
  userProfileData
) => {
  let gender = userProfileData.gender;
  gender = gender ? gender.toLowerCase() : '';
  segment.identify(userProfileData.user_id, {
    firstName: userProfileData.name || '',
    lastName: userProfileData.last_name || '',
    gender: gender,
    avatar: userProfileData.profile_pic_url || '',
    phone: userProfileData.phone_number,
    email: userProfileData.email || '',
    countryCode: userProfileData.country_code || ''
  });
};
